import * as React from "react";
import { IconLoadingDots } from "../Icons";
import classNames from "classnames";

interface PaymentButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
}

const PaymentButton = ({
  className,
  children,
  disabled,
  type = "submit",
  loading,
  ...props
}: PaymentButtonProps) => {
  const isDisabled = disabled || loading;
  const loadingIndicator = (
    <>
      &nbsp;
      <IconLoadingDots />
    </>
  );

  const buttonStyles = classNames(
    "button button-primary button-lg w-full",
    isDisabled ? "opacity-20" : "opacity-100",
    className
  );

  return (
    <button
      type={type}
      className={buttonStyles}
      disabled={isDisabled}
      {...props}
    >
      {loading ? loadingIndicator : children}
    </button>
  );
};

export default PaymentButton;
